import { createAction, props } from '@ngrx/store';
import { FormState } from './formEntreprise.reducer';

export const loadForm = createAction('[FormEntreprise] Load FormEntreprise');

export const saveForm = createAction('[FormEntreprise] Save FormEntreprise');

export const updateForm = createAction(
    '[Form] Update FormEntreprise',
    props<FormState>()
);

